import { system } from '@olist/styled-system';
import styled from 'styled-components';

const Box = styled.div `
  box-sizing: border-box;
  ${system}
`;

export { Box };
